export const biometryApi = Object.freeze({
  getBiometryConfig: `biometry-public-api/getConfig`,
  createBiometry: `biometry-private-api/create`,
  getBiometryStatus: `biometry-private-api/getActualStatus`,
  uploadPhotos: `biometry-private-api/uploadPhoto`,
});
